import React from "react";
import { HERR_VON_MUELLERHOFF_WOFF2 } from "../admin/signatureFont";

// Single source of truth for the author's signature mark. The name and the oxblood
// curve are drawn together inside ONE SVG whose script font is embedded as a
// base64 @font-face. Because the font travels with the SVG, it rasterizes
// identically in the browser AND in html2canvas exports (PDF / PNG), keeping the
// curve perfectly aligned beneath the name everywhere. The title sits below as HTML.
export const SIGNATURE_CURVE = "M40 128 C 175 146, 305 146, 440 122";

const FONT_FACE = `@font-face{font-family:'RQ Signature';font-style:normal;font-weight:400;src:url(data:font/woff2;base64,${HERR_VON_MUELLERHOFF_WOFF2}) format('woff2');}`;

export const AuthorSignature = React.forwardRef(
  (
    {
      className = "",
      name = "Zukiswa Phoofolo",
      title = "Writer-Anthropologist",
      nameColor = "#1C1A17",
      accent = "#7A2E2E",
      titleColor = "#7A2E2E",
      scale = 1,
    },
    ref
  ) => (
    <div
      ref={ref}
      className={className}
      data-testid="author-signature"
      style={{ display: "inline-block", textAlign: "center" }}
    >
      <svg
        viewBox="0 0 480 160"
        width={330 * scale}
        height={110 * scale}
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block", overflow: "visible" }}
        role="img"
        aria-label={`Signature of ${name}`}
      >
        <defs>
          <style>{FONT_FACE}</style>
        </defs>
        <text
          x="240"
          y="104"
          textAnchor="middle"
          fontFamily="'RQ Signature', cursive"
          fontSize="92"
          fill={nameColor}
        >
          {name}
        </text>
        <path d={SIGNATURE_CURVE} stroke={accent} strokeWidth="2" fill="none" strokeLinecap="round" />
      </svg>
      <p
        style={{ marginTop: `${10 * scale}px`, color: titleColor, fontSize: `${11 * scale}px` }}
        className="uppercase tracking-[0.34em]"
      >
        {title}
      </p>
    </div>
  )
);
